// core version + navigation, pagination modules:
import Swiper, { Autoplay } from 'imports/swiper'
let home = {
    swiperBig:null,
    init: function () {
        
    }
}
export default home
